import { render } from "./Profile.vue?vue&type=template&id=ec7e1824&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=ec7e1824&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ec7e1824"

export default script